import FormatLogic from '../../../../../utils/formatLogicUtil';

export function getHeaderStatusText({ isNotStarted, isComplete, submittedDate }) {
  if (isNotStarted) {
    return 'Application not started';
  }

  if (isComplete) {
    if (!submittedDate) {
      return 'Applied';
    }
    return `Applied ${FormatLogic.monthDayYear(submittedDate)}, ${FormatLogic.localTimeFromDate(submittedDate)}`;
  }

  return 'Application started, not submitted';
}
